"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnifiedWorkspaces() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="234646" id="schlank-im-liegen" className="bg-background text-foreground py-24 md:py-32 overflow-hidden relative min-h-[600px] flex items-center">
      <div className="absolute inset-0 z-0">
        <img src="http://bodyconcept-allendorf-eder.de/wp-content/uploads/2026/06/Bodyconcept_linda_Schlank-im-liegen-NEU.jpg" className="w-full object-cover opacity-50 !bg-[rgba(245,189,255,0)] !h-[1000px]" loading="lazy" alt="" />
        <div className="absolute inset-0 from-background via-background/80 to-transparent !bg-[rgba(106,55,99,0.27)]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div ref={textRef} className={`lg:col-span-6 flex flex-col items-start transition-all duration-700 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="leading-tight mb-6 !font-default !text-[rgba(155,2,130,1)] !w-[670px] !font-bold !text-[50px]">Schlank im Liegen – <br />Deine Abkürzung <br />zur Wunschfigur</h2>
            <p className="font-default mb-8 leading-relaxed max-w-2xl !text-3xl !w-[660px] !font-extrabold text-secondary">Effektiv, entspannt und <br />mit Sofort-Effekt.</p>
            
            <a href="#contactus" className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-primary/20 bg-[rgba(154,4,112,1)] text-white font-extrabold text-white">
              Jetzt Termin buchen
              <ArrowRight className="ml-2 size-4" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}